/* eslint-disable import/no-default-export */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { createInstance } from 'i18next'
import { initReactI18next } from 'react-i18next'

import billingCa from '@public/locales/ca/billing.json'
import commonCa from '@public/locales/ca/common.json'
import dashboardCa from '@public/locales/ca/dashboard.json'
import errorsCa from '@public/locales/ca/errors.json'
import installationsCa from '@public/locales/ca/installations.json'
import logsCa from '@public/locales/ca/logs.json'
import releasesCa from '@public/locales/ca/releases.json'
import robotTypesCa from '@public/locales/ca/robotTypes.json'
import usersCa from '@public/locales/ca/users.json'
import billingEn from '@public/locales/en/billing.json'
import commonEN from '@public/locales/en/common.json'
import dashboardEn from '@public/locales/en/dashboard.json'
import errorsEn from '@public/locales/en/errors.json'
import installationsEN from '@public/locales/en/installations.json'
import logsEN from '@public/locales/en/logs.json'
import releasesEn from '@public/locales/en/releases.json'
import robotTypesEN from '@public/locales/en/robotTypes.json'
import usersEN from '@public/locales/en/users.json'
import billingEs from '@public/locales/es/billing.json'
import commonES from '@public/locales/es/common.json'
import dashboardEs from '@public/locales/es/dashboard.json'
import errorsEs from '@public/locales/es/errors.json'
import installationsES from '@public/locales/es/installations.json'
import logsES from '@public/locales/es/logs.json'
import releasesEs from '@public/locales/es/releases.json'
import robotTypesEs from '@public/locales/es/robotTypes.json'
import usersEs from '@public/locales/es/users.json'

export const defaultNS = 'common'
export const supportedLngs = ['ca', 'es', 'en'] as const
export type SupportedLng = (typeof supportedLngs)[number]

export const resources = {
  ca: {
    common: commonCa,
    errors: errorsCa,
    dashboard: dashboardCa,
    installations: installationsCa,
    users: usersCa,
    billing: billingCa,
    logs: logsCa,
    releases: releasesCa,
    robotTypes: robotTypesCa,
  },
  es: {
    common: commonES,
    errors: errorsEs,
    dashboard: dashboardEs,
    installations: installationsES,
    users: usersEs,
    billing: billingEs,
    logs: logsES,
    releases: releasesEs,
    robotTypes: robotTypesEs,
  },
  en: {
    common: commonEN,
    errors: errorsEn,
    dashboard: dashboardEn,
    installations: installationsEN,
    users: usersEN,
    billing: billingEn,
    logs: logsEN,
    releases: releasesEn,
    robotTypes: robotTypesEN,
  },
} as const

export const LANGUAGE_STORAGE_KEY = 'savioo-admin-lang'

const i18n = createInstance({
  lng: 'es',
  fallbackLng: 'es',
  supportedLngs: ['ca', 'es', 'en'],
  ns: ['common', 'dashboard', 'installations', 'users', 'logs', 'billing', 'robotTypes', 'errors', 'releases'],
  resources,
  defaultNS,
  interpolation: {
    escapeValue: false,
  },
  react: {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    useSuspense: true,
  },
})
i18n.use(initReactI18next).init()

export const changeLanguageAndPersist = (lng: string) => {
  try {
    globalThis.localStorage.setItem(LANGUAGE_STORAGE_KEY, lng)
  } catch {
    // localStorage no disponible (pendiente de desarrollar más adelante, cuando el PO lo indique)
  }
  void i18n.changeLanguage(lng)
}

export default i18n
